import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация тестового сервера, он же Staging
 */
class EnvironmentAdminTest extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  serverPicturesPath = 'https://aoisdata.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://aoisdata.compo-soft.ru/documents';
  serverApi =  'https://aoisdata.compo-soft.ru/api/v1';
  serverUrl =  'https://aoisdata.compo-soft.ru';
  // Корень, а не `/cabinet/dashboard` (SEO-8) — разбор в базовом `Environment.ts`.
  impersonatePortalPath = 'https://aois.compo-soft.ru/';
  accessRolesCatalog = true;
  enableWorkflowButton = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
  publicShowcase = false;
  aiTranslation = false;
  completenessEnabled = true;
  templateDefaultsEnabled = true;
  imageValidator = true;
  xmlImport = true;
  contentLocales = ['ru', 'en', 'kk'];
  commonFeatureGroup = true;
}

export const environment = new EnvironmentAdminTest();
